<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add Contribution</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="contribution.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                         <br>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                VAT
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                 <md-input v-model="contribution.vat" />
                                 <validation-error :errors="apiValidationErrors.description" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                With Holding Tax
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="contribution.withholding_tax" />
                                    <validation-error :errors="apiValidationErrors.withholding_tax" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Active
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="contribution.is_active" name="is_active">
                                        <md-option value=1>Yes</md-option>
                                        <md-option value=0>No</md-option>
                                    </md-select>
                                </md-field>
                                <validation-error :errors="apiValidationErrors.is_active" />
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Contribution</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({

        contribution: {
            type: 'contributions',
            name: null,
            vat: null,
            withholding_tax: null,
            is_active: null
        },
    }),

    methods: {
        async add () {
            try {
                await this.$store.dispatch('contributions/add', this.contribution);
                this.notifySuccess('Contribution added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'List Contributions' });
        },
    },
};
</script>
<style lang="scss" scoped>
    .spacing {
        padding-bottom: 1rem;
    }

    .md-inline-checkboxes {
        display: inline-flex;

        .md-checkbox {
            margin-top: 15px !important;
        }
    }

    .md-checkbox,
    .md-radio {
        margin-top: 15px;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

    .md-radio .md-radio-container {
        margin-left: 5px;
        position: relative;
        left: -3px;
    }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding-left: 0;
        padding-top: 10px;
        min-height: 150px;
    }

    .md-field:after,
    .md-field:before {
        bottom: 10px !important;
    }
</style>
<style >
    .ck-editor__editable {
        min-height: 200px;
        width: auto;
    }
</style>

